import { render, staticRenderFns } from "./paperDetail.html?vue&type=template&id=d79e48e2&"
import script from "./paperDetail.js?vue&type=script&lang=js&"
export * from "./paperDetail.js?vue&type=script&lang=js&"
import style0 from "./paperDetail.styl?vue&type=style&index=0&lang=styl&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports